import { generateName, strCompareLowerCase } from '@common/Common';
import WorkspaceNavigation from '@common/Components/WorkspaceNavigation.vue';
import { ICommandStatus } from '@cqrs/cqrs';
import { DiscreteScaleEditorViewModel } from '@Scales/Components/DiscreteScaleEditor';
import DiscreteScaleEditor from '@Scales/Components/DiscreteScaleEditor.vue';
import { CreateWorkspaceScaleCommandV1, DeleteWorkspaceScaleCommandV1, UpdateWorkspaceScaleCommandV1 } from '@Scales/Domain/commands-core';
import ScalesCommands from '@Scales/Domain/commands-vue-component';
import ScalesQueries from '@Scales/Domain/queries-vue-component';
import { DiscreteScaleLevelReadModel, DiscreteScaleReadModel, TchScaleTemplatesListReadModel, WorkspaceScalesListReadModel } from '@Scales/Domain/readmodels';
import Component, { mixins } from 'vue-class-component';


@Component({
    components: { WorkspaceNavigation, DiscreteScaleEditor }
})
export default class WorkspaceScalesPage extends mixins(ScalesQueries, ScalesCommands)
{
    get workspaceId(): number { return parseInt(this.$route.params.workspaceId); }

    rm: WorkspaceScalesListReadModel | null = null;
    discreteScaleEditor = new DiscreteScaleEditorViewModel();
    tchTemplates: DiscreteScaleReadModel[] | null = null;

    get workspaceName(): string | null { return this.rm?.WorkspaceName; }
    get scales(): DiscreteScaleReadModel[] { return this.rm?.Scales ?? []; }
    get scalesView(): DiscreteScaleReadModel[] { return this.scales.sort((a, b) => strCompareLowerCase(a.Name, b.Name)); }

    mounted()
    {
        document.title = "Scales | TransparentChoice";
        this.runWorkspaceScalesListQueryV1(this.workspaceId);
        this.runTchScaleTemplatesListQueryV1(this.workspaceId);
    }


    showScaleCreator(tchTemplate: DiscreteScaleReadModel | null)
    {
        if (tchTemplate)
        {
            const scale = { ...tchTemplate };

            this.discreteScaleEditor.showCreator(scale.Name, scale.Description, scale.Levels);
        }
        else            
        {
            const name = generateName("Scale");
            this.discreteScaleEditor.showCreator(name, null, [new DiscreteScaleLevelReadModel(), new DiscreteScaleLevelReadModel(), new DiscreteScaleLevelReadModel()]);
        }
    }

    showScaleEditor(rm: DiscreteScaleReadModel)
    {
        this.discreteScaleEditor.showEditor(rm.Id, rm.Name, rm.Description, rm.Levels);
    }


    handleCreateWorkspaceScaleCommand(name: string, description: string | null, levels: string)
    {
        this.invokeCreateWorkspaceScaleCommandV1(this.workspaceId, 0, name, description, levels);
    }

    handleDeleteWorkspaceScaleCommand(scaleId: number)
    {
        this.invokeDeleteWorkspaceScaleCommandV1(this.workspaceId, scaleId);
    }

    handleUpdateWorkspaceScaleCommand(scaleId: number, name: string, description: string | null, levels: string)
    {
        this.invokeUpdateWorkspaceScaleCommandV1(this.workspaceId, scaleId, name, description, levels);
    }


    onSetModel(model: any, modelName: string)
    {
        if (modelName === "WorkspaceScalesListReadModel")
        {
            this.rm = model as WorkspaceScalesListReadModel;
        }
        else if (modelName === "TchScaleTemplatesListReadModel")
        {
            const rm = model as TchScaleTemplatesListReadModel;
            this.tchTemplates = rm.Templates;
        }
    }

    onCommandSucceed(cmd: any, correlationId: string)
    {
        if (CreateWorkspaceScaleCommandV1.matchType(cmd))
        {
            this.runWorkspaceScalesListQueryV1(this.workspaceId);
            this.discreteScaleEditor.close();
        }
        if (DeleteWorkspaceScaleCommandV1.matchType(cmd))
        {
            this.runWorkspaceScalesListQueryV1(this.workspaceId);
            this.discreteScaleEditor.close();
        }
        else if (UpdateWorkspaceScaleCommandV1.matchType(cmd))
        {
            this.runWorkspaceScalesListQueryV1(this.workspaceId);
            this.discreteScaleEditor.close();
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (CreateWorkspaceScaleCommandV1.matchType(status.Command))
        {
            this.discreteScaleEditor.displayValidationErrors(status.ValidationErrors);
        }
        else if (UpdateWorkspaceScaleCommandV1.matchType(status.Command))
        {
            this.discreteScaleEditor.displayValidationErrors(status.ValidationErrors);
        }
    }

}